import { UPDATE_COLUMN_TEXT_INPUT, UPDATE_TEXT_INPUT, CHANGE_PROFILE_STATUS, UNLOCK_AUDIO_DIALOG_SHOWN, UNLOCK_SAMPLE_DIALOG_SHOWN, SHOW_SAMPLE_UNLOCK_DIALOG, SET_SELECTION_ITEM_ELEMENT, } from '../actions';
const initialState = {
    textInput: '',
    smsOrEmail: '',
    profileStatus: '',
    selectorItemElement: '',
    unlockAudioDialogShown: false,
    showSampleUnlockDialog: false,
};
export function DialogReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_TEXT_INPUT:
            return Object.assign(Object.assign({}, state), action.payload);
        case UPDATE_COLUMN_TEXT_INPUT:
            return Object.assign(Object.assign({}, state), { smsOrEmail: action.payload.smsOrEmail || '' });
        case CHANGE_PROFILE_STATUS:
            return Object.assign(Object.assign({}, state), { profileStatus: action.payload.profileStatus || '' });
        case UNLOCK_AUDIO_DIALOG_SHOWN:
            return Object.assign(Object.assign({}, state), { unlockAudioDialogShown: true });
        case UNLOCK_SAMPLE_DIALOG_SHOWN:
            return Object.assign(Object.assign({}, state), { showSampleUnlockDialog: false });
        case SHOW_SAMPLE_UNLOCK_DIALOG:
            return Object.assign(Object.assign({}, state), { showSampleUnlockDialog: true });
        case SET_SELECTION_ITEM_ELEMENT:
            return Object.assign(Object.assign({}, state), { selectorItemElement: action.payload.selectorItemElement || '' });
        default:
            return state;
    }
}
